export const COPYRIGHT_I18N = {
  pt: {
    copy: 'Desenvolvido por',
    contact: 'Contacto',
    links: 'Links',
  },
  en: {
    copy: 'Developed by',
    contact: 'Contact',
    links: 'Links',
  },
};
